<template>
  <div
    class="flex w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 content-center min-w-card"
    @click="visitFolder"
  >
    <div class="card card-content card--interactive text-center">
      <div class="flex-item">
        <div class="icon icon--large mb-2">
          <SimpleSVG filepath="/svg/folder.svg" />
        </div>
        <h3 class="mb-1">
          <a
            :href="detailUrl"
            v-text="title"
          />
        </h3>
        <h5
          class="mt-0 mb-4 uppercase"
          v-html="documentCount"
        />
        <a
          class="btn btn--sm btn--icon-only icon icon--small"
          :href="detailUrl"
        >
          <SimpleSVG filepath="/svg/pencil.svg" />
        </a>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import { SimpleSVG } from 'vue-simple-svg'

export default {
  name: 'Folder',
  components: {
    SimpleSVG,
  },
  props: {
    folder: {
      type: Object,
      required: true,
    },
  },
  computed: {
    detailUrl() {
      return this.$urlGenerator.active() + 'documents/folders/' + this.folder.uuid
    },
    title() {
      return this.folder.attributes.title
    },
    documentCount() {
      if (this.folder.attributes.item_count === 0) {
        return 'Empty'
      }

      return this.folder.attributes.item_count === 1
        ? '1 item'
        : `${this.folder.attributes.item_count} items`
    },
  },
  methods: {
    visitFolder() {
      window.location = this.detailUrl
    },
  },
}
</script>
